import { PLANS_CONSTANTS } from "../constants/planConstants";

const initialState = {
  planDetails: [],
  loading: false,
  error: null
};

const planReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLANS_CONSTANTS.FETCH_PLAN_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case PLANS_CONSTANTS.FETCH_PLAN_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        planDetails: action.payload,
        error: null
      };
    case PLANS_CONSTANTS.FETCH_PLAN_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default planReducer;